module.exports = __webpack_public_path__ + "static/media/plane-alt.fd0869cb.svg";